/* hs-eslint ignored failing-rules */

'use es6';

import lang from 'i2l?query=sporks!../../lang/en.lyaml';
import BasicPublicI18nSetup from 'I18n/init/setup/BasicPublicI18nSetup';

// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom';
import UIApplication from 'UIComponents/app/UIApplication';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../../rhumb-config.yaml';
import FeedbackForm from '../containers/FeedbackForm';
import manualRhumb from './manualRhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const shouldLoad = !window.jasmine;
class Application {
  start() {
    if (!shouldLoad) return;
    window.AppInstance = this;
    BasicPublicI18nSetup.setup({
      lang
    }).then(() => {
      const {
        updateRoute,
        rhumbHistory
      } = manualRhumb();
      render( /*#__PURE__*/_jsx(UIApplication, {
        name: "feedback-web-renderer-ui",
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          config: rhumbConfig,
          history: rhumbHistory('/'),
          children: /*#__PURE__*/_jsx(FeedbackForm, {
            updateRoute: updateRoute
          })
        })
      }), document.getElementById('servicehub-feedback'));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
}
new Application().start();